import { render, staticRenderFns } from "./ReportGroupingSection.vue?vue&type=template&id=636f8613&"
import script from "./ReportGroupingSection.vue?vue&type=script&lang=js&"
export * from "./ReportGroupingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports